import {
    apiConstants,
} from '../config';

let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

export const getDefaultState = () => {
    return {
        error: null,
        loading: false,
        data: {
            code: code,
            codeAPI: codeAPI,
            module: {},
            panels: {
                home: {
                    acl: {
                        view: null,
                    },
                    url: {
                        getMenu: `${codeAPI}/:applicationCode/front/os/sidebar/menu`,
                        getPage: `${codeAPI}/:applicationCode/front/os/sidebar/page/:slug`,
                    },
                    menu: {
                        loaded: false,
                        items: []
                    },
                    page: {
                        title: null,
                        content: null,
                        slug: null,
                        label: null,
                        icon: null,
                        default: null,
                        order: null,
                    }
                },
                headernav: {
                    tools: [
                        {component: 'dashboard', title: 'dashboard.title'},
                    ]
                },
            },
            tools: {
                backoffice: {
                    active: false,
                    title: 'backoffice.titles',
                    label: 'backoffice.label',
                    panel: {
                        show: false,
                    },
                    acl: {
                        view: null,
                    },
                    url: {
                        view: `{moduleCode}gestao.home`
                    }
                },
                layers: {
                    active: false,
                    title: 'layers.titles',
                    label: 'layers.label',
                    panel: {
                        show: false,
                        loaded: false,
                    },
                    acl: {
                        view: null,
                    },
                    url: {
                        getLayers: `${codeAPI}/:applicationCode/front/map/map/layers`,
                    },
                    selected: null,
                },
                dashboard: {
                    active: true,
                    panel: {
                        show: false,
                        loaded: false,
                    },
                    acl: {
                        view: null,
                    },
                },
                regulations: {
                    active: false,
                    title: 'regulations.titles',
                    label: 'regulations.label',
                    panel: {
                        show: false,
                        loaded: false,
                    },
                    acl: {
                        view: null,
                    },
                    url: {
                        getData: `${codeAPI}/:applicationCode/front/map/regulations`,
                    },
                },
                navsearch: {
                    active: false,
                    panel: {
                        show: true,
                        showDefault: true,
                        categories: [{
                            'id': 'addr',
                            'name': 'navsearch.address.title',
                            'url': '../gateway/address/search',
                            'listGroup': 'adminName1',
                            'labelTemplate': 'navsearch.address.labelTemplate',
                            'subLabelTemplate': null,
                            'placeholder': 'navsearch.address.placeholder'
                        }],
                        search: {
                            category: null,
                            item: null,
                            search: null,
                        },
                    },
                },
                catalog: {
                    active: false,
                    acl: {
                        view: null,
                    },
                },
                identify: {
                    active: false,
                    acl: {
                        view: null,
                    },
                },
                annotations: {
                    active: false,
                    acl: {
                        view: null,
                    },
                },
                measure: {
                    active: false,
                    acl: {
                        view: null,
                    },
                },
                print_visible_emissions: {
                    active: false,
                    title: 'print_visible_emissions.titles',
                    label: 'print_visible_emissions.label',
                    panel: {
                        show: false,
                        loaded: false,
                    },
                    acl: {
                        view: null,
                    },
                    url: {
                        capabilitiesPrint: `${codeAPI}/:applicationCode/front/map/print/visible/capabilities`,
                        createPrint: `${codeAPI}/:applicationCode/front/map/print/visible`,
                        getStatusPrint: `${codeAPI}/:applicationCode/front/map/print/visible/job/:id`,
                    }
                },
            },
            map: {

            }
        },
    };
};

const state = getDefaultState();

export default state;